import { render, staticRenderFns } from "./EventsMap.vue?vue&type=template&id=bc604fde&"
import script from "./EventsMap.vue?vue&type=script&lang=js&"
export * from "./EventsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/T7/BACKUP/repositories/reveil-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc604fde')) {
      api.createRecord('bc604fde', component.options)
    } else {
      api.reload('bc604fde', component.options)
    }
    module.hot.accept("./EventsMap.vue?vue&type=template&id=bc604fde&", function () {
      api.rerender('bc604fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/EventsMap.vue"
export default component.exports